import type { AhoyPropertyType } from '../types';

const MAILCHIMP_TO_AHOY_TYPE: Record<string, AhoyPropertyType> = {
  text: 'string',
  dropdown: 'string',
  radio: 'string',
  number: 'number',
  date: 'date',
  birthday: 'date',
  address: 'string',
  imageurl: 'string',
  phone: 'string',
  zip: 'string',
  email: 'string',
  checkboxes: 'multi_select',
};

/** Infer the Ahoy property type to create for a given Mailchimp merge-field type. */
export function inferAhoyType(mailchimpType: string): AhoyPropertyType {
  return MAILCHIMP_TO_AHOY_TYPE[mailchimpType] ?? 'string';
}

/** Slugify an external field name into a valid Ahoy property-name fragment. */
export function toPropertySlug(s: string): string {
  return s.replace(/[^a-z0-9]/g, '_');
}
